<template>
  <a href="#" data-test-id="btn_close" class="icon icon_close" @click.prevent>
    <i class="icon icon-close"></i>
  </a>
</template>
